import { LEGAL_LAST_UPDATED } from '@/constants/site.constants';
import { RENTAL_TERMS_CONTENT } from '@/features/legal/constants/rentalTerms.constants';
import { useDocumentTitle } from '@/hooks/useDocumentTitle.hook';
import type { LegalDocumentContent } from '@/types/legal.types';

interface UseRentalTermsPageResult {
  content: LegalDocumentContent;
  lastUpdated: string;
}

export const useRentalTermsPage = (): UseRentalTermsPageResult => {
  useDocumentTitle(
    'Rentals Terms & Conditions | Shoutt',
    'The terms that govern listing, booking and returning items through Shoutt Rentals, including deposits, cancellations and disputes.',
  );

  return { content: RENTAL_TERMS_CONTENT, lastUpdated: LEGAL_LAST_UPDATED };
};
